import { Component, Input, ViewChild } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { ApplicantMessage } from '@models/recruiting/applicant-message.model';
import { JobPosting } from '@models/recruiting/job-posting.model';
import { AuthService } from '@app/services';
import { MatSelectModule } from '@angular/material/select';
import { ApplicantMessageTemplate } from '@models/recruiting/applicant-message-template.model';

@Component({
    selector: 'app-recruiting-applicant-message-form',
    templateUrl: './applicant-message.form.html',
})
export class ApplicantMessageForm extends BaseForm {
    @ViewChild('jobFunnelSelect') jobFunnelSelect: MatSelectModule;

    @Input() applicantMessage: ApplicantMessage = new ApplicantMessage();

    jobPostings: JobPosting[];
    selectedJobPosting: JobPosting;

    templateId: number | string = 'free-form';
    applicantMessageTemplates: ApplicantMessageTemplate[];

    constructor(private auth: AuthService) {
        super();
    }

    ngOnInit() {
        ApplicantMessageTemplate.all().then(([applicantMessageTemplates]) => {
            this.applicantMessageTemplates = applicantMessageTemplates;
        });

        JobPosting.param('company', this.auth.company.id)
            .orderBy('createdAt', 'desc')
            .with('jobFunnels')
            .all()
            .then(([jobPostings]) => {
                this.jobPostings = jobPostings;

                if (this.applicantMessage.jobPostingId) {
                    this.onJobPostingChange();
                }
            });
    }

    onJobPostingChange() {
        this.applicantMessage.jobFunnelId = null;

        this.selectedJobPosting = this.jobPostings.find(
            (jobPosting) => jobPosting.id === this.applicantMessage.jobPostingId
        );
    }

    onTemplateIdChange() {
        const template = this.applicantMessageTemplates.find((t) => t.id === this.templateId);

        if (!template) {
            this.applicantMessage.subject = '';
            this.applicantMessage.body = '';
            return;
        }

        this.applicantMessage.subject = template.subject;
        this.applicantMessage.body = template.body;
    }
}
